import { InstallmentBody, InstallmentQuery } from "@interfaces/installment"
import KyMethod from "../repositories/KyMethod"

export default class InstallmentRepository extends KyMethod {
  protected async getRawInstallmentList(query: Partial<InstallmentQuery>) {
    return this._getData("/installments", query)
  }

  protected async submitRawInstallment(body: InstallmentBody) {
    return this._protectedCrudMethod("/installments", { body })
  }
}
